<template>
  <div class="form-group">
    <display-refund-alert></display-refund-alert>
    <div id="sumup-card"></div>
  </div>
</template>

<script>
import { StatusEmitterMixin } from '../../../mixins/Shared/StatusEmitterMixin'
import DisplayRefundAlert from '../../BookingPayment/DisplayRefundAlert.vue'

export default {
  name: 'SumUpWidget',
  mixins: [StatusEmitterMixin],
  props: {
    checkoutId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loadingWidget: true,
      error: '',
      completed: false
    }
  },
  computed: {
    status () {
      return {
        error: this.error,
        loading: this.loadingWidget,
        completed: this.completed
      }
    }
  },
  mounted () {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js'
    script.onload = () => {
      if (window.SumUpCard) {
        window.SumUpCard.mount({
          id: 'sumup-card',
          checkoutId: this.checkoutId,
          onResponse: (type, body) => {
            if (type === 'success') {
              this.completed = true
            } else if (type === 'error') {
              this.completed = true
              this.error = body.detail ? body.detail : 'An unknown error occurred.'
            }
          },
          onLoad: () => {
            this.loadingWidget = false
          }
        })
      } else {
        this.error = 'An unknown error occurred.'
      }
    }
    script.onerror = () => {
      this.error = 'An unknown error occurred.'
    }
    document.head.appendChild(script)
  },
  components: {
    'display-refund-alert': DisplayRefundAlert
  }
}
</script>
